module.exports = __webpack_public_path__ + "img/Comic04-4.0e858b4d.png";